/** Average adult reading speed for prose, in words per minute. */
const WORDS_PER_MINUTE = 220;

/**
 * Estimate reading time from a body of (markdown) text.
 *
 * Strips the most common markdown syntax so headings, emphasis markers, and
 * link URLs don't inflate the word count, then rounds up to whole minutes.
 */
export function estimateReadingTime(body: string): string {
  const plain = body
    .replace(/`{1,3}[^`]*`{1,3}/g, ' ') // inline / fenced code
    .replace(/!\[[^\]]*\]\([^)]*\)/g, ' ') // images
    .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1') // links -> link text
    .replace(/[#>*_~`-]/g, ' '); // residual markdown punctuation

  const words = plain.split(/\s+/).filter(Boolean).length;
  const minutes = Math.max(1, Math.round(words / WORDS_PER_MINUTE));
  return `${minutes} min read`;
}
